import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './FavoriteButton.css';

/**
 * Button component for adding/removing bus stops from favorites
 */
const FavoriteButton = ({ busStop, isFavorite, onToggle, showLabel = false }) => {
  const { t } = useTranslation();
  const [label, setLabel] = useState('');
  const [showLabelInput, setShowLabelInput] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleClick = async (e) => {
    e.stopPropagation();

    if (isFavorite) {
      // Remove from favorites
      setIsProcessing(true);
      await onToggle(null);
      setIsProcessing(false);
    } else {
      // Show label input or add with default label
      if (showLabel) {
        setShowLabelInput(true);
      } else {
        setIsProcessing(true);
        await onToggle(t('favorites.labelPlaceholder'));
        setIsProcessing(false);
      }
    }
  };

  const handleSaveLabel = async (e) => {
    e.stopPropagation();
    setIsProcessing(true);
    await onToggle(label.trim());
    setIsProcessing(false);
    setShowLabelInput(false);
    setLabel('');
  };

  const handleCancelLabel = (e) => {
    e.stopPropagation();
    setShowLabelInput(false);
    setLabel('');
  };

  if (showLabelInput) {
    return (
      <div className="favorite-label-dialog" onClick={(e) => e.stopPropagation()}>
        <input
          type="text"
          value={label}
          onChange={(e) => setLabel(e.target.value)}
          placeholder={t('favorites.labelPlaceholder')}
          className="favorite-label-input-small"
          autoFocus
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              handleSaveLabel(e);
            }
          }}
        />
        <div className="favorite-label-actions">
          <button
            onClick={handleSaveLabel}
            className="btn-save-label"
            disabled={isProcessing}
            title={t('favorites.add')}
          >
            ✓
          </button>
          <button
            onClick={handleCancelLabel}
            className="btn-cancel-label"
            disabled={isProcessing}
            title={t('favorites.cancel')}
          >
            ✕
          </button>
        </div>
      </div>
    );
  }

  return (
    <button
      className={`favorite-button ${isFavorite ? 'favorited' : ''}`}
      onClick={handleClick}
      disabled={isProcessing}
      title={isFavorite ? t('favorites.remove') : t('favorites.add')}
    >
      {isProcessing ? '⏳' : isFavorite ? '★' : '☆'}
    </button>
  );
};

export default FavoriteButton;
